import { GameCssStyles } from '../GameCssStyles'
import {
    Box,
    TextField,
    IconButton,
    MenuItem,
    Typography,
    Switch,
    Grid,
    Button
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { useState } from 'react';
import { CONTEST_TYPE, GAME_TYPE } from '../GameConstant';

const defaultRule = {
    ticketPrice: {
        rapCoin: 0,
    },
    win: {
        winPositions: [{ position: 1, rapCoin: 0 }],
    },
    contestType: 'Paid',
    isPromoted: false,
};

const defaultFanstasyRule = {
    ticketPrice: {
        rapCoin: 0,
    },
    win: {
        winPositions: [{ position: 1, rapCoin: 0 }],
    },
    contestType: 'Paid',
    isPromoted: false,
};


const StandardForkContestRulesV2 = ({ formGameData, setFormGameData, handleChange }) => {

    const [shareErrors, setShareErrors] = useState({});
    const forkContestRules = formGameData?.forkContestRules || [];
    const contestType = formGameData?.type;

    const handleChangeLocal = (index, fieldPath, value) => {
        const updated = [...forkContestRules];
        const keys = fieldPath.split('.');
        let obj = updated[index];

        for (let i = 0; i < keys.length - 1; i++) {
            if (!obj[keys[i]]) obj[keys[i]] = {};
            obj = obj[keys[i]];
        }

        obj[keys[keys.length - 1]] = value;

        setFormGameData(prev => ({
            ...prev,
            forkContestRules: updated
        }));
    };

    const getDefaultRules = () => {
        if (contestType === GAME_TYPE.PREDICT_BASED) {
            return defaultRule;
        }
        else if (contestType === GAME_TYPE.FANTASY_LEAGUE_GAME) {
            return defaultFanstasyRule;
        }
        else {
            return defaultRule;
        }
    }

    const addRule = () => {
        handleChange('forkContestRules', [...forkContestRules, JSON.parse(JSON.stringify(getDefaultRules()))]);
    }

    const removeRule = (index) => {
        const updated = [...forkContestRules];
        updated.splice(index, 1);
        setFormGameData(prev => ({
            ...prev,
            forkContestRules: updated
        }));
    };

    const addWinPosition = (ruleIndex) => {
        const updated = [...forkContestRules];
        const rule = updated[ruleIndex];
        const currentTotalShare = rule?.win?.winPositions?.reduce((sum, pos) => sum + (pos.rapCoin || 0), 0);

        console.log("currentTotalShare : ", currentTotalShare)

        const nextPosition = rule.win.winPositions.length + 1;

        rule.win.winPositions.push({
            position: nextPosition,
            rapCoin: 0,
        });

        setFormGameData(prev => ({
            ...prev,
            forkContestRules: updated
        }));
    };

    const removeWinPosition = (ruleIndex, posIndex) => {
        const updated = [...forkContestRules];
        updated[ruleIndex]?.win?.winPositions?.splice(posIndex, 1);
        setFormGameData(prev => ({
            ...prev,
            forkContestRules: updated
        }));
    };

    return (
        <Box sx={GameCssStyles.containerStyleColumn_sx}>
            <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game Contest Rules</Typography>

            <Box sx={GameCssStyles.containerStyleColumnWithoutBorder_sx}>
                {forkContestRules?.map((rule, index) => (
                    <Box
                        key={index}
                        sx={{
                            border: '1px solid #ccc',
                            borderRadius: 2,
                            p: 2,
                            mb: 2,
                            background: '#f4f1f9',
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid>
                                <TextField
                                    select
                                    fullWidth
                                    label="Contest Type"
                                    value={rule?.contestType ?? ''}
                                    onChange={(e) =>
                                        handleChangeLocal(index, 'contestType', e.target.value)
                                    }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px', justifyContent: 'flex-start', alignContent: 'flex-start', textAlign: 'left' }}
                                >
                                    <MenuItem value="Paid">Paid</MenuItem>
                                    <MenuItem value="Practice">Practice</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid>
                                <TextField
                                    fullWidth
                                    label="Ticket Price (Rapcoin)"
                                    type="number"
                                    value={rule?.ticketPrice?.rapCoin}
                                    onChange={(e) =>
                                        handleChangeLocal(index, 'ticketPrice.rapCoin', e.target.value)
                                    }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px' }}
                                />
                            </Grid>
                            <Grid>
                                <Box display="flex" alignItems="center">
                                    <Typography mr={1}>Promoted</Typography>
                                    <Switch
                                        checked={rule?.isPromoted}
                                        onChange={(e) =>
                                            handleChangeLocal(index, 'isPromoted', e.target.checked)
                                        }
                                        sx={GameCssStyles.switchStyle_sx}
                                    />
                                </Box>
                            </Grid>

                            {/* Win Positions */}
                            <Box sx={{ width: '100%' }}>
                                {rule?.win?.winPositions.map((pos, posIndex) => (
                                    <Grid key={posIndex}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            gap={2}
                                            mb={1}
                                            sx={{ flexWrap: 'wrap' }}
                                        >
                                            <TextField
                                                label={`Position ${posIndex + 1}`}
                                                type="number"
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                value={pos.position}
                                                onChange={(e) =>
                                                    handleChangeLocal(index, `win.winPositions.${posIndex}.position`, parseInt(e.target.value))
                                                }
                                                sx={GameCssStyles.formSingleLineTextField_sx}
                                            />

                                            <TextField
                                                label="RapCoin"
                                                type="number"
                                                value={pos?.rapCoin}
                                                onChange={(e) => {
                                                    const val = e.target.value;

                                                    // if (posIndex > 0) {
                                                    //     const prevShare = rule?.win?.winPositions[posIndex - 1]?.rapCoin || 0;
                                                    //     if (val > prevShare) {
                                                    //         setShareErrors(prev => ({
                                                    //             ...prev,
                                                    //             [`${index}_${posIndex}`]: "Each position must have a smaller RaCoin than the previous one",
                                                    //         }));
                                                    //         return;
                                                    //     }
                                                    // }

                                                    handleChangeLocal(index, `win.winPositions.${posIndex}.rapCoin`, parseInt(val));
                                                }}
                                                error={Boolean(shareErrors[`${index}_${posIndex}`])}
                                                helperText={shareErrors[`${index}_${posIndex}`] || ""}
                                                sx={GameCssStyles.formSingleLineTextField_sx}
                                            />

                                            <IconButton
                                                onClick={() => removeWinPosition(index, posIndex)}
                                                color="error"
                                                size="small"
                                                sx={{ backgroundColor: "#bebebeff" }}
                                            >
                                                <Remove />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                ))}

                                <Grid textAlign="left" justifyContent={"center"} alignContent={"center"}>
                                    <Button
                                        variant="contained"
                                        onClick={() => addWinPosition(index)}
                                    >
                                        + Add Win Position
                                    </Button>
                                </Grid>
                            </Box>

                            <Box width="100%" textAlign="right" mt={2}>
                                <Button
                                    variant="contained"
                                    sx={{ backgroundColor: "#f44336", color: "#fff" }}
                                    onClick={() => removeRule(index)}
                                >
                                    Remove Rule
                                </Button>
                            </Box>
                        </Grid>
                    </Box>
                ))}

                <Box textAlign="right" mt={2}>
                    <Button variant="contained" color="primary" onClick={addRule}>
                        <Add /> Add Rule
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default StandardForkContestRulesV2
